import { render, staticRenderFns } from "./CandidateEditForm.vue?vue&type=template&id=dea384d2&"
import script from "./CandidateEditForm.vue?vue&type=script&lang=js&"
export * from "./CandidateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports